import axios from "@/modules/axios";
import router from "@/modules/router";

const getQuery = () => router.currentRoute.query;

export default {
	namespaced: true,

	state: {
		loaded: false,
		data: []
	},

	mutations: {
		data(state, data) {
			state.data = data;
		},
		loaded(state) {
			state.loaded = true;
		}
	},

	actions: {
		async data({commit, state}, {query, route} = {}) {
			const params = {
				filter: {...getQuery(), ...query},
				count: 1000
			};

			try {
				const {data: {data}} = await axios.get("client/products", {params});
				commit("data", data);
			} catch(err) {
				// ignore error
			} finally {
				if (!state.loaded) commit("loaded");
			}

			if (route !== false) {
				router.replace({query: {...getQuery(), ...query}}); // save new query

				if (router.name !== "products") { // redirect to index
					router.push({query: getQuery(), name: "products"});
				}

				window.scrollTo(0, 0);
			}
		}
	},

	getters: {
		data(state) {
			return state.data;
		},
		loaded(state) {
			return state.loaded;
		},
		categories(state, getters, rootState, rootGetters) {
			return [...rootGetters["categories/data"], {id: null, name: "other"}];
		},
		groups(state, getters) {
			const categories = getters.categories;
			const items = getters.data;

			return categories.map(cat => ({
				...cat,
				items: items.filter(item => item.category_id === cat.id)
			}));
		}
	}
};
